import { DEVICE_FILTER_OPTIONS } from './DeviceFilterType';
import type { AbstractSingleFilterPillsProps } from '../SingleFilterType';
import { GenericShortListFilter } from '../GenericBloc/GenericShortListFilter/GenericShortListFilter';
import type { DEVICE_TYPE } from './DeviceFilterType';
import { FilterKindEnum } from '../../../../domains/global-filters/model/FilterChain';
import { getFilterMetadata } from '../../FilterChainUtils';

export function DeviceTypeFilter({
  currentValue,
  autoFocus,
  onApply,
  onRemove,
  onDropdownHidden,
  showDropdownOnMount,
}: AbstractSingleFilterPillsProps<DEVICE_TYPE[]>): JSX.Element {
  const metadata = getFilterMetadata(FilterKindEnum.DeviceType);
  return (
    <GenericShortListFilter
      autoFocus={autoFocus}
      filterName={metadata.filterName}
      iconName={metadata.iconName}
      currentValue={currentValue}
      onApply={onApply}
      onRemove={onRemove}
      optionList={DEVICE_FILTER_OPTIONS}
      onDropdownHidden={onDropdownHidden}
      showDropdownOnMount={showDropdownOnMount}
    />
  );
}
